var React = require('react');

function IconGlossaryBookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M0 .5v35.562a1.774 1.774 0 0 0 2.793 1.45L14 29.668l11.207 7.846A1.774 1.774 0 0 0 28 36.062V.5H0Z"}));
}

IconGlossaryBookmark.defaultProps = {"fill":"none","viewBox":"0 0 28 38"};

module.exports = IconGlossaryBookmark;

IconGlossaryBookmark.default = IconGlossaryBookmark;
